import importAll from "import-all.macro";

import * as R from "ramda";
import PropTypes from "prop-types";
import { Global, css } from "@emotion/react";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import React, { memo, useMemo } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { RawIntlProvider } from "react-intl";
import console from "Utils/console";

// if (process.env.NODE_ENV === "development") {
//     const whyDidYouRender = require("@welldone-software/why-did-you-render");
//     whyDidYouRender(React, {
//         trackAllPureComponents: true,
//     });
// }
        
const debugMode = window?.location?.search?.includes("debug");

if (!debugMode) {
    console();
}

importAll.sync("../../production_assets/fonts/*.@(eot|svg|ttf|woff|woff2|otf)");

/* SSR ONLY */
//import createEmotionServer from "create-emotion-server";
//import { renderToString } from "react-dom/server";
/* SSR ONLY END */

import { useIntlLoader } from "./intl";

import fonts from "./theme/constants/fonts.json";
import theme from "./theme/theme";
import { store } from "./store";

if (process.env.STORYBOOK_IS_STORYBOOK){
    const { worker } = require("Apimocks/browser");
    worker.start();
}

const cache = createCache();
//cache.compat = true;

const globalStyle = ({ root }) => css`
    ${root} {
        *, &::after, &::before {
            box-sizing: border-box;
        }
    }
  ${Object.values(fonts).map(/* eslint-disable no-undef */
        ({ family, weight, style, name }) => `@font-face {
    font-family: '${family}';
        src: url('${__webpack_public_path__}fonts/${name}.eot');
        src: url('${__webpack_public_path__}fonts/${name}.eot?#iefix') format('embedded-opentype'),
            url('${__webpack_public_path__}fonts/${name}.woff2') format('woff2'),
            url('${__webpack_public_path__}fonts/${name}.woff') format('woff'),
            url('${__webpack_public_path__}fonts/${name}.eot') format('embedded-opentype'),
            url('${__webpack_public_path__}fonts/${name}.ttf') format('truetype'),
            url('${__webpack_public_path__}fonts/${name}.svg#${name}') format('svg');
    font-weight: ${weight};
    font-style: ${style};
    font-display: swap;
 }`
/* eslint-enable no-undef */)}
`;

export const Provider = memo(({ children, rootSelector = "html", store: xstore = store }) => {
    const finalTheme = useMemo(() => R.mergeDeepLeft(
        {},
        theme({ root: rootSelector }) /* Todo: add overwrites from redux state */
    ), [rootSelector]);
    const globalStyles = useMemo(() => globalStyle({ root: rootSelector }), [rootSelector]);

    const intlProv = useIntlLoader(); // lang=auto, client=auto

    return (
        <CacheProvider value={cache}>
            <ReduxProvider store={xstore}>
                <RawIntlProvider value={intlProv}>
                    <ColorModeScript initialColorMode="light" />
                    <ChakraProvider
                        theme={finalTheme}
                    >
                        <Global styles={globalStyles} />
                        {children}
                    </ChakraProvider>
                </RawIntlProvider>
            </ReduxProvider>
        </CacheProvider>
    );
});
Provider.displayName = "Global MD Provider";
Provider.propTypes = { children: PropTypes.node.isRequired, rootSelector: PropTypes.string, store: PropTypes.shape() };
Provider.defaultProps = { rootSelector: "html", store: undefined };
Provider.store = store;
export default Provider;

//const { extractCritical } = createEmotionServer(cache);
//const styles = extractCritical(renderToString(Provider));

